module.exports = __webpack_public_path__ + "img/p4.a8bfc308.jpg";